export default "__VITE_ASSET__6866385a__"